module.exports = __webpack_public_path__ + "img/group_add_opsz24B.d533bcf8.svg";